import { useEffect } from "react";

import { FiltersContainer } from "../../filters/ui/FiltersContainer";

import { AdsTypeFilter } from "./AdsType";
import { useAdsAlertsFilterStore } from "./useAdsAlertsFilterStore";

export const AdsAlertsFilters = () => {
    const reset = useAdsAlertsFilterStore((state) => state.reset);

    useEffect(() => reset, [reset]);

    return (
        <FiltersContainer>
            <AdsTypeFilter />
        </FiltersContainer>
    );
};
